import { Progress } from "@/components/ui/progress";

interface TestProgressProps {
  currentQuestionIndex: number;
  totalQuestions: number;
}

export const TestProgress = ({ currentQuestionIndex, totalQuestions }: TestProgressProps) => {
  // Calculate progress based on completed questions (current index, not +1)
  const progress = (currentQuestionIndex / totalQuestions) * 100;
  
  return (
    <div className="mb-6">
      <div className="flex justify-between text-sm text-gray-600 mb-2">
        <span>Question {currentQuestionIndex + 1} of {totalQuestions}</span>
        <span>{Math.round(progress)}% Complete</span>
      </div>
      <Progress value={progress} className="h-2" />
    </div>
  );
};